export type TGender = "OTHER" | "MALE" | "FEMALE";

export type TModuleValue = "A1" | "M2" | "F2" | "M3" | "F3" | "A4";

export type TModuleOption = {
  moduleLabel: string;
  name: string;
  value: TModuleValue;
  gender: TGender;
  genderLabel: "Masculino" | "Feminino" | "Feminino ou Masculino";
};

export const moduleOptions: TModuleOption[] = [
  {
    moduleLabel: "Módulo I",
    name: "18-30 anos",
    value: "A1",
    gender: "OTHER",
    genderLabel: "Feminino ou Masculino",
  },
  {
    moduleLabel: "Módulo II",
    name: "31-50 anos",
    value: "M2",
    gender: "MALE",
    genderLabel: "Masculino",
  },
  {
    moduleLabel: "Módulo II",
    name: "31-50 anos",
    value: "F2",
    gender: "FEMALE",
    genderLabel: "Feminino",
  },
  {
    moduleLabel: "Módulo III",
    name: "> 50 anos",
    value: "M3",
    gender: "MALE",
    genderLabel: "Masculino",
  },
  {
    moduleLabel: "Módulo III",
    name: "> 50 anos",
    value: "F3",
    gender: "FEMALE",
    genderLabel: "Feminino",
  },
  {
    moduleLabel: "Módulo IV",
    name: "> 31 anos",
    value: "A4",
    gender: "OTHER",
    genderLabel: "Feminino ou Masculino",
  },
];
